<input
  #numberInput
  type="number"
  class="form-input flex-2"
  [value]="numberValue()"
  [id]="id()"
  [required]="required()"
  (input)="onInput()"
  (blur)="onTouched()" />
<app-select
  class="flex-1"
  [items]="unitItems()"
  [value]="unit()"
  (valueChange)="onUnitChange($any($event))"
  (touchedChange)="onTouched()" />
